import { FC, useMemo, useState } from "react";

import { IPeopleBlockParams, PeopleBlockStatus } from "Bands/types";
import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons, IAPIError } from "shared/types";
import { copy } from "shared/assets";
import { getFields } from "./formData";

const peopleBlockCopy = copy.peopleBlock.editStatus;

interface PeopleBlockStatusFormProps {
  currentStatus?: PeopleBlockStatus;
  handleSubmit: (data: IPeopleBlockParams) => void;
  handleCancel: () => void;
  apiStatus?: IAPIState;
  error?: boolean | string;
  apiError?: IAPIError | null;
}

export const PeopleBlockStatusForm: FC<PeopleBlockStatusFormProps> = ({
  apiStatus,
  error,
  currentStatus,
  apiError,
  handleSubmit,
  handleCancel,
}) => {
  const [selectedStatus, setSelectedStatus] =
    useState<PeopleBlockStatus | null | undefined>(null);

  const buttons: IFormButtons = useMemo(
    () => ({
      primary: {
        children:
          selectedStatus === PeopleBlockStatus.rsvp
            ? peopleBlockCopy.buttons.sendRSVP
            : peopleBlockCopy.buttons.updateStatus,
        size: "m",
      },
      secondary: {
        size: "m",
        onClick: handleCancel,
      },
    }),
    [handleCancel, selectedStatus]
  );

  return (
    <FormBuilder
      submitMode="isDirty"
      fields={getFields({
        currentStatus,
        onStatusChange: (status) => setSelectedStatus(status),
      })}
      buttons={buttons}
      onSubmit={handleSubmit}
      isSubmitting={apiStatus === IAPIState.pending}
      apiErrorMessage={error}
      dataTestId="people_block_status_form"
      apiError={apiError}
    />
  );
};
